/**
* @name: header-bar-page
* @author: weiyong
* @date: 2023-05-11 18:24
* @description：header-bar-page
* @update: 2023-05-11 18:24
*/
<template>
  <header :class="[prefixCls,getHeaderClass]" class="el-header environmental-header is-pageHeader" :style="'--el-custom-header-bg-color:'+getHeaderBgColor">
    <div class="header-left flex-div">
      <!-- logo -->
      <AppLogo
        :showLogo="getShowLogo"
        :class="[`${prefixCls}-logo`,getHeaderTheme]"
        :theme="getHeaderTheme"
        :showTitle="getShowSystemTitle!==false"
        :style="getLogoWidth"
      />
      <!-- 绿色环保主题不展示顶部首页/门户切换按钮 -->
    </div>
    <div class="header-right" :style="headerRightSty">
      <!--普通用户新手指引-->
      <zhiyinUser :class="`${prefixCls}-action__item  icon-item`" v-if="isNewUser"></zhiyinUser>
      <!-- 单位管理员新手指引-->
      <zhiyinUnitAdmin :class="`${prefixCls}-action__item  icon-item`" v-if="isNewUnitAdmin"></zhiyinUnitAdmin>
      <XmTenantDropdown  />
      <AppLocalePicker class="icon-item"
                       :reload="true"
                       :showText="false"
      />
      <Notify style="padding:0 12px;" curLayout="environmental" v-if="getShowNotice" :class="`${prefixCls}-action__item notify-item`" />

      <AppSearch :class="`${prefixCls}-action__item  icon-item`" v-if="getShowSearch"/>
      <FullScreen :class="`${prefixCls}-action__item fullscreen-item  icon-item`" v-if="getShowFullScreen" />

<!--      机构下拉-->
<!--      <org-drop-down-sca class="icon-item no-right-padding" ></org-drop-down-sca>-->
      <!--用户下拉-->
      <user-drop-down-sca class="icon-item no-right-padding"/>
<!--不要屏蔽 这里异步加载的数据 -->
      <SettingDrawer
        v-if="getUserDefLayout !== false"
        :settingLayout="settingLayout"
        :class="[`${prefixCls}-action__item`,'icon-item','SettingDrawer']"
      />
      <UpdateLogIcon class="icon-item"/>
      <xm-icon-help class="icon-item"/>

    </div>
  </header>
</template>

<script lang="ts" setup>
import ZhiyinUser from "@/layouts/layoutFrame/components/zhiyinUser.vue";
import ZhiyinUnitAdmin from "@/layouts/layoutFrame/components/zhiyinUnitAdmin.vue";
import Notify from "@/layouts/default/header/components/notify/index.vue";
import XmIconHelp from "@/layouts/default/header/components/xm-icon-help.vue";
import UpdateLogIcon from "@/layouts/default/header/components/UpdateLogIcon.vue";
import { AppLogo } from '@/components/Application';
import { AppLocalePicker } from '@/components/Application';
import UserDropDownSca from "@/layouts/layoutFrame/scaLayout/components/user-drop-down-sca.vue";
import {AppSearch} from "@/components/Application";
import FullScreen from "@/layouts/default/header/components/FullScreen.vue";
import {useDesign} from "@/hooks/web/useDesign";
import {useHeaderSetting} from "@/hooks/setting/useHeaderSetting";
import {computed, unref} from "vue";
import {useRootSetting} from "@/hooks/setting/useRootSetting";
import { XmTenantDropdown } from '@/components/xm-tenant-and-industry-toggle'
import {createAsyncComponent} from "@/utils/factory/createAsyncComponent";
import {GoingNewUtils, StorageUtils} from 'xmgoing-utils';

defineOptions({
  components: {
    SettingDrawer: createAsyncComponent(() => import('@/layouts/default/setting/index.vue'), {
      loading: true,
    }),
  },
  name: "header-bar-page",
});

const props=defineProps({
  settingLayout:{
    type:Boolean,
    default:true
  }
})

const {  getShowLogo } = useRootSetting();

const isNewUser = computed(()=>{
  return GoingNewUtils.parseBoolean(StorageUtils.getSessionItem("openUserZhiYin"));
})
const isNewUnitAdmin = computed(()=>{
  return GoingNewUtils.parseBoolean(StorageUtils.getSessionItem("openUnitAdminZhiYin"));
})

const {prefixCls} = useDesign('environmental-header-bar-page');

const {
  getIconColor,
  getShowFullScreen,
  getShowSearch,
  getShowNotice,
  getShowSystemTitle,
  getHeaderBgColor,
  getHeaderTheme,
} = useHeaderSetting();

const headerRightSty=computed(()=>{
  const sty={};
  sty['--primary-color']=unref(getIconColor);
  return sty;
})

const getLogoWidth = computed(() => {
  let width = 300;
  if(!unref(getShowLogo)){
    width=width-100;
  }
  if(!unref(getShowSystemTitle)){
    width=width-100;
  }
  return { width: `${width}px`};
});

/**
 * 获取header都主题颜色
 */
const getHeaderClass = computed(() => {
  const theme = unref(getHeaderTheme);
  return [
    prefixCls,
    {
      [`${prefixCls}--${theme}`]: theme,
    },
  ];
});

const { getUserDefLayout } = useRootSetting();

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-environmental-header-bar-page';
@logo-width:55px;

.@{prefix-cls} {
  .SettingDrawer{
    cursor:pointer;
  }
  &-logo {
    height: var(--header-height,48px);

    padding: 0 10px;
    font-size: 14px;
    &.vben-app-logo.dark .vben-app-logo__title{
      color:#333;
    }
    img {
      width: @logo-width;
      height: @logo-width;
      margin-right: 2px;
    }
  }


  &.environmental-header {
    box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
    height: var(--header-height,48px);
    background-color: var(--el-custom-header-bg-color);
    padding: 0 40px;
    display: flex;
    gap: 24px;
    align-items: center;
    position: -webkit-sticky;
    position: sticky;
    justify-content: space-between;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 100;

    .icon {
      color: var(--primary-color, #0a6eff);
      vertical-align: middle;
      margin: 6px 0;
      font-size: 20px;
    }
  }

  .breadcrumb-container {
    height: 32px;
    display: inline-flex;
    align-items: center;
    gap: 24px;
    width: 100%;
  }

  .svg-inline--fa {
    display: var(--fa-display, inline-block);
    height: 1em;
    overflow: visible;
    vertical-align: -0.125em;
  }

  .el-txt.el-txt--h5 {
    font-family: var(--el-font-family);
    font-size: var(--el-h5-font-size);
    font-weight: var(--el-h5-font-weight);
    line-height: var(--el-h5-line-height);
    letter-spacing: var(--el-h5-letter-spacing);
    color: var(--el-text-color-primary, #303133);
  }

  .header-right{
    align-items: center;
    display: flex;
    .icon-item{
        display: inline-block;
      padding: 0 12px;
      &.no-right-padding{
        padding-right: 0;
      }
    }

  }
  .fullscreen-item{
    cursor:pointer;
  }

}
</style>
